<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="Hempleo">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dCincoM dtOcho dmOnce">
                    <h1>¿QUIERES PARTICIPAR CON NOSOTROS?</h1>
                    <p>Si eres medico u odontólogo y buscas un lugar donde ejercer éticamente con libertad, autonomía y gran calidez, acércate con nosotros e involúcrate y se uno más de los 13 mil médicos comodatarios en el país.</p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>
    <div class="contenedorIntSub">
        <div class="FformContacto dDiez dtOnce dmOnceM">
            <form #uno="ngForm"  (ngSubmit)="onSubmit(uno)" ngNativeValidate class="text-left">
                <div class="row">
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="ddl_Area">
                            Trabajo en área:
                        </label>

                        <select ngModel name="AreaTrabajo" class="form-control" [disabled]="isReadonly" (ngModelChange)="getperfil($event)" required>
                            <option *ngFor="let area of areas" [ngValue]="area.idArea"> {{ area.nombreArea }} </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="ddl_Salud">
                            Perfil:
                        </label>
                        <select ngModel name="perfil" class="form-control" [disabled]="isReadonly" required>
                            <option *ngFor="let perfil of perfiles" [ngValue]="perfil.idPerfil"> {{ perfil.nombrePerfil }} </option>
                        </select>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <h2 class="col-12">Datos generales</h2>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="txt_nombre">
                                Nombre:
                        </label>
                        <input ngModel name="nombre" class="form-control" type="nombre" id="nombre" aria-describedby="nombre" required />
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="txt_nombre">
                            Apellido Paterno:
                        </label>
                        <input ngModel name="apellidoPaterno" class="form-control" type="apellidoPaterno" id="apellidoPaterno" aria-describedby="nombre" required />
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="txt_nombre">
                            Apellido Materno:
                        </label>
                        <input ngModel name="apellidoMaterno" class="form-control" type="apellidoMaterno" id="apellidoMaterno" aria-describedby="nombre" required />
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="txt_email">
                            E-mail:
                        </label>
                        <input ngModel name="email" class="form-control" type="email" id="nombre" aria-describedby="email" required />
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="txt_telefono">
                            Teléfono:
                        </label>
                        <input type="tel" maxlength="10" minlength="10" ngModel="telefono" name="telefono" class="form-control" id="telefono"  pattern="[0-9]{10}" required />
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="ddl_Ecivil">
                            Estado civil:
                        </label>
                        <select ngModel name="edocivil" class="form-control" required>
                            <option *ngFor="let civil of civiles" [ngValue]="civil.idEstadoCivil"> {{ civil.estadoCivil }} </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="ddl_Edad">
                            Fecha de Nacimiento:
                        </label>
                        <input type="date" ngModel name="fechanacimiento" class="form-control" id="fechanacimiento" required />
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="txt_nacionalidad">
                            Nacionalidad:
                        </label>
                        <input type="text" ngModel name="Nacionalidad" class="form-control" id="Nacionalidad" />
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="ddl_sexo">
                            Sexo:
                        </label>
                        <select ngModel name="sexo" class="form-control" required>
                            <option *ngFor="let sexo of sexos" [ngValue]="sexo.idSexo"> {{ sexo.sexo }} </option>
                        </select>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <h2 class="col-12">Dirección</h2>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="txt_domicilio">
                            Calle y número:
                        </label>
                        <input type="text" ngModel name="Calle" class="form-control" id="Calle"  required/>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="txt_domicilio">
                            Número Interior:
                        </label>
                        <input type="text" ngModel name="numeroInterior" class="form-control" id="numeroInterior" />
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="txt_domicilio">
                            Número Exterior:
                        </label>
                        <input type="text" ngModel name="numeroExterior" class="form-control" id="numeroExterior"  required />
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="txt_colonia">
                            Colonia:
                        </label>
                        <input type="text" ngModel name="Colonia" class="form-control" id="Colonia" required/>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="txt_cp">
                            Código postal:
                        </label>
                        <input type="tel" maxlength="5" minlength="5" ngModel name="codigoPostal" class="form-control" id="codigoPostal" aria-describedby="codigoPostal" placeholder="" pattern="[0-9]{5}" required />
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="ddl_estado">
                            Estado:
                        </label>
                        <select ngModel name="estadoId" class="form-control" (ngModelChange)="getCiudades($event)" required>
                            <option [ngValue]="" selected>Seleccione Estado</option>
                            <option *ngFor="let estado of estados" [ngValue]="estado.idestado"> {{ estado.nombre | uppercase}} </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="txt_ciudad">
                            Ciudad:
                        </label>
                        <select ngModel name="ciudadId" class="form-control" required>
                            <option [ngValue]="" selected>Seleccione una Municipio o Alcaldía</option>
                            <option *ngFor="let ciudad of ciudades" [ngValue]="ciudad.idMunicipio"> {{ ciudad.nombre | uppercase}} </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="txt_pais">
                            País:
                        </label>
                        <input type="text" ngModel name="Pais" class="form-control" id="Pais" required/>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <h2 class="dDoce">Último grado de estudio</h2>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="txt_escuela">
                            Institución:
                        </label>
                        <input type="text" ngModel name="InstitucionEducativa" class="form-control" id="InstitucionEducativa"  required/>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="ddl_academico">
                            Nivel académico:
                        </label>
                        <select ngModel name="nivelacademico" class="form-control" required>
                            <option *ngFor="let nacademico of nacademicos" [ngValue]="nacademico.idNivelAcademico"> {{ nacademico.nivelAcademico }} </option>
                        </select>        
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="txt_inicio">
                            Año de inicio:
                        </label>
                        <select ngModel name="fechaInicioAcedemico" class="form-control" required>
                            <option *ngFor="let year of years" [ngValue]="year.year"> {{ year.year }} </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="txt_fin">
                            Año de termino:
                        </label>
                        <select ngModel name="fechaFinAcedemico" class="form-control" required>
                            <option *ngFor="let year of years" [ngValue]="year.year"> {{ year.year }} </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="ddl_status">
                            Estatus:
                        </label>
                        <select ngModel name="estatusacademico" class="form-control" required>
                            <option *ngFor="let academico of academicos" [ngValue]="academico.idEstatusAcademico"> {{ academico.estatusAcademico }} </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="txt_cedula">
                            No. de cédula profesional:
                        </label>
                        <input ngModel type="text" name="cedulaProfesiona" class="form-control" maxlength="10" minlength="10" id="cedulaProfesional" />
                    </div>
                    <div class="form-group col-12 flx Fcheck">
                        <div>
                            <ul class="checkbox-items">
                                <li *ngFor="let oestudio of oestudios">
                                <input type="checkbox" name="oestudio.isChecked" class="form-control" id="oestudio.isChecked" [(ngModel)]="oestudio.isChecked" (change)="changeSelection(oestudio.idOtrosEstudios)">{{oestudio.otrosEstudios}}
                                </li>
                            </ul>
                        
                        </div>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <h2 class="col-12">Experiencia laboral</h2>
                    <h3 class="col-12 text-center">Actual o Último Empleo</h3>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="txt_empresa">
                            Empresa:
                        </label>
                        <input type="text" ngModel name="empresa" class="form-control" id="empresa" />
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="ddl_giroempresa">
                           Giro de la empresa:
                        </label>
                        <select ngModel name="giroempresa" class="form-control">
                            <option *ngFor="let empresa of empresas" [ngValue]="empresa.idGiroEmpresa"> {{ empresa.giroEmpresa }} </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="txt_puesto1">
                            Puesto:
                        </label>
                        <input type="text" ngModel name="puesto" class="form-control" id="puesto" />
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="txt_fecha_inicial1">
                            Fecha de inicio:
                        </label>
                        <select ngModel name="fechaInicioUltimoTrabajo" class="form-control">
                            <option *ngFor="let year of years" [ngValue]="year.year"> {{ year.year }} </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="txt_fecha_final1">
                            Fecha de salida:
                        </label>
                        <select ngModel name="fechaFinUltimoTrabajo" class="form-control">
                            <option *ngFor="let year of years" [ngValue]="year.year"> {{ year.year }} </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="ddl_labora">
                            ¿Es su empleo actualmente?
                        </label>
                        <!-- <input list="ddl_labora" ngModel name="laboraactualmente" placeholder="Seleccione" class="laboraactualmente" />
                            <select id="laboraactualmente">
                                <option value="true">Si</option>
                                <option value="false">No</option>
                            </select>
                            <label for="cars">Choose a car:</label> -->
                        <select ngModel name="laboraactualmente" class="form-control laboraactualmente" >
                            <option value="1">si</option>
                            <option value="0">no</option>
                        </select>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                    </div>
                    <h3 class="col-12">Empleo anterior</h3>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="txt_empresa2">
                            Empresa:
                        </label>
                        <input type="text" ngModel name="empresados" class="form-control" id="empresados" />
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="ddl_giroempresa2">
                            Giro de la empresa:
                        </label>
                        <select ngModel name="giroempresados" class="form-control">
                            <option *ngFor="let empresa of empresas" [ngValue]="empresa.idGiroEmpresa"> {{ empresa.giroEmpresa }} </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="txt_puesto2">
                            Puesto:
                        </label>
                        <input type="text" ngModel name="puestodos" class="form-control" id="puestodos" />
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0">
                        <label for="txt_fecha_inicial2">
                            Fecha de inicio:
                        </label>
                        <select ngModel name="fechaInicioPenUltimoTrabajo" class="form-control">
                            <option *ngFor="let year of years" [ngValue]="year.year"> {{ year.year }} </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                        <label for="txt_fecha_final2">
                            Fecha de salida:
                        </label>
                        <select ngModel name="fechaFinPenUltimoTrabajo" class="form-control">
                            <option *ngFor="let year of years" [ngValue]="year.year"> {{ year.year }} </option>
                        </select>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 FupFile">
                        <label for="image" class="cttTitle">Seleccione un archivo:</label>
                        <input type="file" #fileInput id="fileInput" (change)="stageFile($event)"  accept=".pdf" required>
                    </div>
                    <div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
                    </div>
                </div>
                <!-- No hay una razon para que exista el campo de comentarios  -->
                <!-- <div class="cttInp dDoce">
                        <label for="comentarios">
                        Comentarios<br>
                        <textarea name="comentarios" id="comentarios" cols="80" rows="8">
                        </textarea>
                    </label>
                </div> -->
                <div class="row">
                    <button type="button" type="submit" class="btn enviar" *ngIf="send">ENVIAR</button>
                </div>
            </form>
         
        </div>
    </div>

    <div id="Fpreloader"  *ngIf="this.confirma">
        <div class="FbqCen">
            <div class="Floader"></div>
        </div>
    </div>
    <div class="alerta-exito blqCtr text-center" *ngIf="this.succes">
        <img class="ico-confirmar" src="./../../../../assets/images/icons/icono-exito.png">
        <p>Información <strong>enviada</strong> correctamente</p>
    </div>

</div>
